class MobileMenu extends HTMLElement {
    constructor() {
        super();

        const mainMenu = document.querySelector('mobile-menu');
        const body = document.body;
        const burger = document.querySelector('.ecsHeader-burger');
        const mobileTriggers = this.querySelectorAll('.menu-item-mobile');
        const mobileBacks = this.querySelectorAll('.megamenu-inner-back');

        this.querySelector('[data-mobile-menu-close]').addEventListener('click', (e) => {

            this.setAttribute('data-active-index', 'none');

            if (mainMenu) {
                mainMenu.classList.remove('open');
              }

              if (burger) burger.classList.remove('active');
              body.classList.remove('menu-open');
        })


        mobileTriggers.forEach((el) => {
            el.addEventListener('click', (e) => {
                const targetIndex = e.currentTarget.getAttribute('data-index');
                this.setAttribute('data-active-index', targetIndex);
            })
        })


        mobileBacks.forEach((el) => {
            el.addEventListener('click', (e) => {
              this.setAttribute('data-active-index', '');
              requestAnimationFrame(() => {
                this.setAttribute('data-active-index', 'none');
              });
            });
          });
    }


    static get observedAttributes() {
        return ['data-active-index'];
      }


      attributeChangedCallback(name, oldValue, newValue){
        let dataIndex = this.getAttribute("data-active-index");
    
        if(name == 'data-active-index'){
        this.filterByCat(dataIndex);
        }
      }


      filterByCat(i){

        const mobileTriggers = this.querySelectorAll('.menu-item-mobile');

    
        if(i == "none"){
            mobileTriggers.forEach((el) => {
                el.querySelector('.megamenu-mobile').classList.remove('active');
            })

        } else {
            mobileTriggers.forEach((el) => {
                el.querySelector('.megamenu-mobile').classList.remove('active');
            })
            
            this.querySelector(`.menu-item-mobile[data-index="${i}"] .megamenu-mobile`).classList.add('active')
          
        }
      }
    
}

customElements.define('mobile-menu', MobileMenu);